import React from 'react';
import { TaxLiability } from '../types';

interface LiabilitiesTableProps {
  title: string;
  liabilities: TaxLiability[];
}

function formatCurrency(amount: number): string {
  return '£' + amount.toLocaleString('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

const LiabilitiesTable: React.FC<LiabilitiesTableProps> = ({ title, liabilities }) => {
  return (
    <div className="table-section">
      <h2 className="govuk-heading-m">{title}</h2>
      <table className="govuk-table">
        <thead className="govuk-table__head">
          <tr className="govuk-table__row">
            <th className="govuk-table__header">Tax period</th>
            <th className="govuk-table__header">Due date</th>
            <th className="govuk-table__header govuk-table__header--numeric">Amount</th>
            <th className="govuk-table__header">Status</th>
          </tr>
        </thead>
        <tbody className="govuk-table__body">
          {liabilities.map((item, index) => (
            <tr className="govuk-table__row" key={index}>
              <td className="govuk-table__cell">{item.taxPeriod}</td>
              <td className="govuk-table__cell">{item.dueDate}</td>
              <td className="govuk-table__cell govuk-table__cell--numeric">{formatCurrency(item.amount)}</td>
              <td className="govuk-table__cell">
                <span className={`status-tag status-tag--${item.status.toLowerCase()}`}>
                  {item.status}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LiabilitiesTable;
